<template>
	<b-overlay :show="isLoading">
		<b-row class="gap-y-1">
			<b-col cols="12" md="4">
				<h2 class="text-secondary font-weight-bolder">PESO PROMEDIO</h2>
			</b-col>
			<b-col cols="12" md="8" class="d-flex justify-content-end align-items-center gap-x-2">
				<b-input-group size="sm" prepend="Mes" style="max-width: 15rem">
					<b-form-select style="min-width: 6rem" :options="monthOpts" v-model="month" />
				</b-input-group>

				<b-button
					variant="flat-info"
					v-b-tooltip.hover
					title="Ver detalle del peso promedio"
					@click="showAvgDetailModal = true"
				>
					<FeatherIcon icon="InfoIcon" size="20" />
				</b-button>
			</b-col>
		</b-row>
		<hr />
		<VueApexCharts type="bar" height="300" :options="chartOpts" :series="chartData" />
		<AverageWeightDetailModal v-if="showAvgDetailModal" @close="showAvgDetailModal = false" />
	</b-overlay>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import AverageWeightDetailModal from "@/views/amg/specimens/components/mainDashboard/AverageWeightDetailModal.vue"
export default {
	components: { VueApexCharts, AverageWeightDetailModal, AverageWeightDetailModal },
	props: { year: Number, info: Array, isLoading: Boolean },
	data: () => ({
		showAvgDetailModal: false,
		month: new Date().getMonth() + 1,
		monthOptsBase: [
			{ value: 1, text: "Enero" },
			{ value: 2, text: "Febrero" },
			{ value: 3, text: "Marzo" },
			{ value: 4, text: "Abril" },
			{ value: 5, text: "Mayo" },
			{ value: 6, text: "Junio" },
			{ value: 7, text: "Julio" },
			{ value: 8, text: "Agosto" },
			{ value: 9, text: "Septiembre" },
			{ value: 10, text: "Octubre" },
			{ value: 11, text: "Noviembre" },
			{ value: 12, text: "Diciembre" },
		],
		monthOpts: [
			{ value: 1, text: "Enero" },
			{ value: 2, text: "Febrero" },
			{ value: 3, text: "Marzo" },
			{ value: 4, text: "Abril" },
			{ value: 5, text: "Mayo" },
			{ value: 6, text: "Junio" },
			{ value: 7, text: "Julio" },
			{ value: 8, text: "Agosto" },
			{ value: 9, text: "Septiembre" },
			{ value: 10, text: "Octubre" },
			{ value: 11, text: "Noviembre" },
			{ value: 12, text: "Diciembre" },
		],
		range: 25,
		chartData: [
			{
				name: "Raza",
				data: new Array(6).fill(3),
			},
		],
		chartOpts: {
			labels: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"],
			colors: ["#2C3E50"],
			fill: {
				type: "gradient",
				gradient: {
					shade: "light",
					type: "horizontal",
					shadeIntensity: 0.25,
					gradientToColors: undefined,
					inverseColors: true,
					opacityFrom: 0.85,
					opacityTo: 0.85,
					stops: [50, 0, 100],
				},
			},
		},
	}),
	methods: {
		async getData() {
			const actualYear = new Date().getFullYear()
			const actualMonth = new Date().getMonth() + 1
			this.monthOpts = this.monthOptsBase.filter((m) => {
				return m.value <= actualMonth || this.year < actualYear
			})
			this.chartData = [
				{
					name: "Kg Peso Promedio",
					data: this.info.map((d) => d.avg_kg_weight),
				},
				{
					name: "Lb Peso Promedio",
					data: this.info.map((d) => d.avg_pounds_weight),
				},
			]
			this.chartOpts = {
				labels: this.info.map((d) => d.category_name),
				colors: ["#00cfe8", "#28c76f", "#ff9f43", "#ea5455"],
			}
		},
		changeMonth() {
			this.$emit("refresh", { year: this.year, month: this.month })
		},
	},
	watch: {
		info() {
			this.getData()
		},
		month() {
			this.changeMonth()
		},
	},
}
</script>
